<template>
  <article
    :class="commentBubbleClasses"
    :aria-label="props.ariaLabel"
    data-cy="ds-comment-bubble"
  >
    <div
      v-if="hasDefaultSlotContent"
      :class="DS_COMMENT_BUBBLE_CLASSES.Content"
      data-cy="ds-comment-bubble__content"
    >
      <slot />
    </div>
  </article>
</template>

<script setup lang="ts">
import { computed, useSlots } from "vue";
import type { DSCommentBubbleProps } from "@/src/design_system/data_display/comment_bubble/types";
import { DS_COMMENT_BUBBLE_CLASSES } from "@/src/design_system/data_display/comment_bubble/constants";
import { hasSlotContent } from "@/src/shared/utils/slots";

const props = withDefaults(defineProps<DSCommentBubbleProps>(), {
  isOwn: false,
  ariaLabel: undefined,
});

const slots = useSlots();

const hasDefaultSlotContent = computed(() => {
  return hasSlotContent(slots);
});

const commentBubbleClasses = computed(() => [
  DS_COMMENT_BUBBLE_CLASSES.Root,
  props.isOwn ? DS_COMMENT_BUBBLE_CLASSES.Own : DS_COMMENT_BUBBLE_CLASSES.Other,
]);
</script>
